export class UpdateAccountRequest {
  autoRenew: boolean;
}
